module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Aktive faste tillæg i OPUS")]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v("\n          " + _vm._s(_vm.userName) + " · " + _vm._s(_vm.employmentLabel) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__toolbar d-modal__toolbar--end"
  }, [(!_vm.isShowCreate) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("\n        Opret fast tillæg\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isShowCreate) ? _c('div', {
    staticClass: "create-form"
  }, [_c('h3', {
    staticClass: "create-form__title"
  }, [_vm._v("Nyt fast tillæg")]), _vm._v(" "), _c('div', {
    staticClass: "create-form__grid"
  }, [_c('div', {
    staticClass: "d-input-group create-form__loenkode"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Lønkode *")]), _vm._v(" "), _c('DSelect', {
    ref: "loenkodeSelect",
    attrs: {
      "items": _vm.salaryCodesForDSelect,
      "multiple": false,
      "placeholder": 'Vælg lønkode',
      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
      "isShowRemoveButton": false
    },
    on: {
      "add": _vm.onSelectLoenkode,
      "remove": function($event) {
        return _vm.onSelectLoenkode(null)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group create-form__antal"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("\n              Antal *\n              "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        placement: 'top',
        zIndex: 12312312312314
      }),
      expression: "{\n                      arrow: true,\n                      animateFill: false,\n                      animation: 'shift-away',\n                      boundary: 'window',\n                      placement: 'top',\n                      zIndex: 12312312312314\n                    }"
    }],
    staticClass: "icon-question3 d-label__help",
    attrs: {
      "content": "Antal enheder pr. måned, der ganges med satsen for den valgte lønkode. Satsen er defineret i KMD OPUS.<br><br>Eksempel: Hvis satsen for den valgte lønkode er 500 kr., og du angiver 2 enheder, udbetales 1.000 kr. pr. måned."
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.antal),
      expression: "createForm.antal"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "Indtast antal"
    },
    domProps: {
      "value": (_vm.createForm.antal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "antal", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group create-form__beloeb"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Beløb")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.beloeb),
      expression: "createForm.beloeb"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "(valgfri)"
    },
    domProps: {
      "value": (_vm.createForm.beloeb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "beloeb", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "create-form__hint text-explainer"
  }, [_vm._v("\n            Udfyld Antal, Beløb eller begge afhængigt af lønkoden.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group create-form__start"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Startdato *")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.createForm.startdato,
      "width100": true
    },
    on: {
      "changed": function($event) {
        _vm.createForm.startdato = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group create-form__slut"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Slutdato *")]), _vm._v(" "), (!_vm.createForm.noEndDate) ? _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.createForm.stopdato,
      "width100": true
    },
    on: {
      "changed": function($event) {
        _vm.createForm.stopdato = $event
      }
    }
  }) : _c('input', {
    staticClass: "d-input width-100",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.openEndedDateLabel
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "create-form__no-end-date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.noEndDate),
      expression: "createForm.noEndDate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.noEndDate) ? _vm._i(_vm.createForm.noEndDate, null) > -1 : (_vm.createForm.noEndDate)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.createForm.noEndDate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "noEndDate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "noEndDate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "noEndDate", $$c)
        }
      }, _vm.onToggleNoEndDate]
    }
  }), _vm._v(" "), _c('span', [_vm._v("Uden slutdato")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group create-form__cost-center"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Afvigende omkostningssted")]), _vm._v(" "), _c('DSelect', {
    attrs: {
      "items": _vm.costCentersForDSelect,
      "multiple": false,
      "placeholder": 'Vælg afvigende omkostningssted (valgfri)',
      "itemsSelected": _vm.selectedCostCenterForDSelect,
      "isShowRemoveButton": true
    },
    on: {
      "add": _vm.onSelectCostCenter,
      "remove": function($event) {
        return _vm.onSelectCostCenter(null)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.createOverlapWarning) ? _c('p', {
    staticClass: "text-explainer create-form__warning"
  }, [_vm._v("\n          " + _vm._s(_vm.createOverlapWarning) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.createValidationMessage) ? _c('p', {
    staticClass: "text-explainer text-explainer--danger"
  }, [_vm._v("\n          " + _vm._s(_vm.createValidationMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "create-form__actions"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeCreate
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isCreating,
      'do-bttn--submit--disabled': !_vm.isCreateValid
    },
    attrs: {
      "disabled": !_vm.isCreateValid || _vm.isCreating
    },
    on: {
      "click": _vm.submitCreate
    }
  }, [_vm._v("\n            Send til OPUS\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "isLoaderModal": true
    }
  }) : [_c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "td-loenkode"
  }, [_vm._v("LØNKODE")]), _vm._v(" "), _c('th', {
    staticClass: "td-units"
  }, [_vm._v("ENHEDER")]), _vm._v(" "), _c('th', {
    staticClass: "td-units"
  }, [_vm._v("BELØB")]), _vm._v(" "), _c('th', {
    staticClass: "td-date"
  }, [_vm._v("FRA")]), _vm._v(" "), _c('th', {
    staticClass: "td-date"
  }, [_vm._v("TIL")]), _vm._v(" "), _c('th', [_vm._v("OMK.STED")]), _vm._v(" "), _c('th', {
    staticClass: "th-actions"
  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedPayments.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 7
    }
  }, [_vm._v("\n              Ingen faste tillæg i OPUS\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedPayments), function(row) {
    return _c('tr', {
      key: row.id != null ? row.id : row.objekt_id,
      staticClass: "fast-tillaeg-row"
    }, [_c('td', {
      staticClass: "td-loenkode"
    }, [_vm._v(_vm._s(row.vLoenart))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.antal)))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.beloeb)))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(row.vFraDato))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(row.vTilDato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.afv_omkostningssted || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "td-actions"
    }, [_c('DDropdown', {
      attrs: {
        "isBottomStart": false,
        "isShowDots": false
      }
    }, [_c('button', {
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n                  Handlinger "), _c('span', {
      staticClass: "icon-arrow-down5"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "action-menu",
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.openStop(row)
        }
      }
    }, [_vm._v("Sæt stopdato")]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.openExtend(row)
        }
      }
    }, [_vm._v("Forlæng")]), _vm._v(" "), _c('li', {
      staticClass: "d-item-warning",
      on: {
        "click": function($event) {
          return _vm.openDelete(row)
        }
      }
    }, [_vm._v("Slet")])])])], 1)])
  })], 2)])]], 2)])]), _vm._v(" "), (_vm.rowToStop) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312313"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": _vm.closeAction
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--small",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Stop fast tillæg")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.closeAction
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', [_vm._v("Tillægget stopper på den valgte dato. Dette kan ikke fortrydes.")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Stopdato *")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.stopDate,
      "maxDate": _vm.stopMaxDate,
      "width100": true
    },
    on: {
      "changed": function($event) {
        _vm.stopDate = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.actionError) ? _c('p', {
    staticClass: "text-explainer text-explainer--danger"
  }, [_vm._v(_vm._s(_vm.actionError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeAction
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingAction
    },
    attrs: {
      "disabled": _vm.isSubmittingAction || !_vm.stopDate
    },
    on: {
      "click": _vm.submitStop
    }
  }, [_vm._v("\n            Stop tillæg\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.rowToExtend) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312313"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": _vm.closeAction
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--small",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Forlæng fast tillæg")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.closeAction
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', [_vm._v("Der oprettes et nyt tillæg med samme lønart, beløb og bemærkning fra den nuværende stopdato til den nye\n          dato.")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Ny slutdato *")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.extendDate,
      "minDate": _vm.extendMinDate,
      "width100": true
    },
    on: {
      "changed": function($event) {
        _vm.extendDate = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.actionError) ? _c('p', {
    staticClass: "text-explainer text-explainer--danger"
  }, [_vm._v(_vm._s(_vm.actionError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeAction
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingAction
    },
    attrs: {
      "disabled": _vm.isSubmittingAction || !_vm.extendDate
    },
    on: {
      "click": _vm.submitExtend
    }
  }, [_vm._v("\n            Forlæng tillæg\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.rowToDelete) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312313"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": _vm.closeAction
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--small",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Slet fast tillæg")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.closeAction
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', [_vm._v("Er du sikker på, at du vil slette dette tillæg helt? Det fjernes fra lønsystemet og kan ikke\n          gendannes.")]), _vm._v(" "), (_vm.actionError) ? _c('p', {
    staticClass: "text-explainer text-explainer--danger"
  }, [_vm._v(_vm._s(_vm.actionError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeAction
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--danger",
    class: {
      'do-bttn--submit--loading': _vm.isSubmittingAction
    },
    attrs: {
      "disabled": _vm.isSubmittingAction
    },
    on: {
      "click": _vm.submitDelete
    }
  }, [_vm._v("\n            Slet tillæg\n          ")])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-640bc18d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/FasteTillaegModal.vue
// module id = 1962
// module chunks = 1